/* KC Gallery — horizontaal schuivende productrij.

   Waarom dit bestand los staat van de sectie: de sleeplogica hieronder is
   het deel dat het vaakst bijgesteld wordt. Los bestand = kleine wijziging.

   De bug die dit oplost: slepen was geregeld met setPointerCapture op de
   rij plus preventDefault op pointerdown. Daardoor kwamen pointerup EN de
   click niet meer op de <a> terecht maar op de rij zelf, want de browser
   bepaalt het doelwit van een click uit de gemeenschappelijke voorouder
   van mousedown en mouseup. Gevolg: geen enkele kaart was nog aan te
   klikken op desktop (op touch wel, want die tak slaat de sleeplogica
   over). De oplossing: pas pointer capture pakken zodra er echt gesleept
   wordt - meer dan 4px - en nooit preventDefault op pointerdown. Een
   gewone klik raakt de sleeplogica dan niet meer aan.                     */
(function () {
  function init(wrap) {
    var track = wrap.querySelector('.kc-gallery-grid');
    if (!track || track.dataset.kcInit === '1') return;
    track.dataset.kcInit = '1';

    var foot  = wrap.querySelector('.kc-gallery-foot');
    var thumb = wrap.querySelector('.kc-gallery-rail-thumb');
    var prev  = wrap.querySelector('[data-kc-prev]');
    var next  = wrap.querySelector('[data-kc-next]');

    function step() {
      var card = track.querySelector('div');
      if (!card) return track.clientWidth;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      /* niets te schuiven: de balk en de pijlen zijn dan dode ballast */
      if (foot) foot.style.display = (max <= 1) ? 'none' : 'flex';
      if (thumb && max > 1) {
        var ratio = track.clientWidth / track.scrollWidth;
        thumb.style.width = (ratio * 100) + '%';
        thumb.style.transform = 'translateX(' + ((track.scrollLeft / max) * (100 / ratio - 100)) + '%)';
      }
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    }

    /* scroll-snap-type: mandatory breekt een programmatische smooth scroll -
       hij snapt telkens terug naar het punt waar de animatie begon, waardoor
       de pijlen niets deden. Snapping even uitzetten voor de duur van de
       beweging, daarna terugzetten zodat slepen en vegen blijven vastklikken. */
    var snapTimer = null;
    function slide(dir) {
      track.style.scrollSnapType = 'none';
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
      clearTimeout(snapTimer);
      snapTimer = setTimeout(function () { track.style.scrollSnapType = ''; }, 700);
    }
    if (prev) prev.addEventListener('click', function () { slide(-1); });
    if (next) next.addEventListener('click', function () { slide(1); });

    /* Slepen met de muis - een desktopbezoeker kan niet vegen. */
    var down = false, startX = 0, startLeft = 0, dragged = false, pid = null;

    /* een sleep die op een <a> of <img> begint zou anders de native
       HTML5-drag van de browser starten */
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    Array.prototype.forEach.call(track.querySelectorAll('img, a'), function (el) {
      el.setAttribute('draggable', 'false');
    });

    function endDrag() {
      if (!down) return;
      down = false;
      if (pid !== null && track.releasePointerCapture) {
        try { track.releasePointerCapture(pid); } catch (err) {}
      }
      pid = null;
      track.classList.remove('is-dragging');
    }

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;      /* touch schuift vanzelf */
      if (e.button !== 0) return;                 /* alleen linkermuisknop */
      if (track.scrollWidth - track.clientWidth <= 1) return;
      down = true; dragged = false;
      startX = e.clientX; startLeft = track.scrollLeft;
      pid = e.pointerId;
      /* BEWUST geen preventDefault en geen setPointerCapture hier: allebei
         verplaatsen het doelwit van de click naar deze rij, waarna de
         browser de link van de kaart niet meer volgt. */
    });

    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragged) {
        if (Math.abs(dx) <= 4) return;            /* nog steeds een klik */
        dragged = true;
        track.classList.add('is-dragging');
        /* nu pas vastpakken: vanaf hier is het een sleep, geen klik */
        if (track.setPointerCapture) { try { track.setPointerCapture(pid); } catch (err) {} }
      }
      e.preventDefault();
      track.scrollLeft = startLeft - dx;
    });

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('blur', endDrag);

    /* een sleep die op een kaart eindigt mag de link niet volgen */
    track.addEventListener('click', function (e) {
      if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; }
    }, true);

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) { new ResizeObserver(update).observe(track); }
    update();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.kc-gallery-wrap'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* de theme editor hangt secties opnieuw in de pagina */
  document.addEventListener('shopify:section:load', boot);
})();
